import React, {useState} from "react";
import {Layout, Divider, Row, Col, Modal} from "antd";
import PageHeader from "../../layouts/PageHeader";
import {iconMapping} from "../../configs/AppsConfig";
import IndexCard from "../../components/IndexCard";
import PdfPreview from "../../components/PdfPreview";
import {ClientAdvantageBulletPoints, FiniatSolutionBulletPoints, MarketBulletPoints} from "./indexCardConfig";
import { useScreenHeight, useScreenWidth } from "../../hooks/useScreen";
import {fetchContentGroupByName} from "../../api/contentGroups";

const BANNER_PDFS = [
    {
        title: "IA Pillars",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/Brochures/IA%203%20Pillars.pdf',
        scale: 0.65
    },
    {
        title: "Taxes in Active Turnover Strategies",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/onePagers/Understanding%20Taxes%20in%20Strategies%20with%20Turnover.pdf'
    }
]

const pdfConfig = [
    {
        title: "Whitepaper",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/whitepapers/Intelligent%20Allocation%20%28Styled%29.pdf'
    },
    {
        title: "Beta as an Outcome",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/reports/Beta%20as%20an%20Outcome%2C%20Not%20a%20Target%20v2.pdf'
    },
    {
        title: "Debunking Goals Based Investing",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/reports/Debunking%20Goal%20Based%20Investing.pdf'
    },
    {
        title: "What we Do",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/reports/What%20We%20Do.pdf'
    },

]

const Resources = ()=>{
    const [showModal, setShowModal] = useState(false);
    const [selectedIndexCard, setSelectedIndexCard] = useState(null);
    const orderedIndexCards =[
        ClientAdvantageBulletPoints,
        FiniatSolutionBulletPoints,
        MarketBulletPoints
    ];
    const screenHeight = useScreenHeight();
    const screenWidth = useScreenWidth();
    const handleCardClick = (cardConfig)=>{
        setShowModal(true);
        setSelectedIndexCard(cardConfig);
    }

    return (
        <Layout>
            <PageHeader title={'Resources'} logoUrl={iconMapping.resources}/>
            <Layout.Content className={'p-6'}>
                <Row wrap={false}>
                    <Col flex={'0 0 600px'} className={'pt-8'}>
                        {orderedIndexCards.map((card, index) => (
                            <div style={{marginTop: index>0?'-30px':0}}>
                                <IndexCard key={index} {...card} onCardClick={()=>handleCardClick(card)} shadow={true}/>
                            </div>
                            )
                        )}
                    </Col>
                    <Col flex={'auto'}>
                        <Row>
                            <Col xs={24} xl={12}>
                                <Row justify={'center'} wrap={true}>
                                    {BANNER_PDFS.map((pdf, index) => (
                                        <Col key={index} span={24}>
                                            <div>
                                                <PdfPreview
                                                    bucketUrl={pdf.url}
                                                    title={pdf.title}
                                                    width={350}  // Fixed width
                                                    height={screenHeight * 0.5} // Fixed height
                                                    scale={pdf?.scale ?? 0.5}
                                                />
                                            </div>
                                        </Col>
                                    ))}
                                </Row>

                            </Col>
                            <Col xs={24} xl={12}>
                                <Row gutter={[24, 24]} justify={'start'} wrap={true}>
                                    {pdfConfig.map((pdf, index) => (
                                        <Col key={index} xs={24} xl={12}>
                                            <PdfPreview
                                                bucketUrl={pdf.url}
                                                title={pdf.title}
                                                width={200}  // Fixed width
                                                height={260} // Fixed height
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Layout.Content>
            <Modal className={'transparent'} width={650} open={showModal} onCancel={()=>setShowModal(false)} onOk={()=>setShowModal(false)}>
                <IndexCard {...selectedIndexCard} size={'large'} shadow={true}/>
            </Modal>
        </Layout>
    )
}

export default Resources;